import React from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField
} from '@mui/material';

const UserPTOTab = ({ formData, handleInputChange }) => {
  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        Hours Balance
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        YTD Used is automatically calculated from Leave/PTO timecards for the current year.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            name="yearStart"
            label="Year Start"
            type="number"
            fullWidth
            value={formData.yearStart}
            onChange={handleInputChange}
            InputProps={{ inputProps: { min: 0, step: 0.5 } }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            name="ytdAccumulated"
            label="YTD Accumulated"
            type="number"
            fullWidth
            value={formData.ytdAccumulated}
            onChange={handleInputChange}
            InputProps={{ inputProps: { min: 0, step: 0.5 } }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            name="ytdUsed"
            label="YTD Used (Auto)"
            type="number"
            fullWidth
            value={formData.ytdUsed}
            InputProps={{ 
              readOnly: true,
              inputProps: { min: 0, step: 0.5 }
            }}
            helperText="Calculated from timecards"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            label="Available"
            type="number"
            fullWidth
            value={(parseFloat(formData.yearStart) + parseFloat(formData.ytdAccumulated) - parseFloat(formData.ytdUsed)).toFixed(2)}
            InputProps={{ readOnly: true }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserPTOTab;
